<div class="chat-modal-backdrop" *ngIf="isOpen" (click)="close()">
  <div class="chat-modal" (click)="$event.stopPropagation()" [class.wide-mode]="isWideMode">
    <div class="chat-header">
      <div class="header-left">
        <img [src]="logoSrc" alt="Logo" class="logo" />
        <span class="ai-assist-text">AI Assist</span>
      </div>
      <div class="header-controls">
        <i class="bi" [ngClass]="isMuted ? 'bi-volume-mute-fill' : 'bi-volume-up-fill'"
          [title]="isMuted ? 'Unmute AI voice' : 'Mute AI voice'" (click)="toggleMute()" role="button" tabindex="0"
          [attr.aria-label]="isMuted ? 'Unmute AI voice' : 'Mute AI voice'" (keydown.enter)="toggleMute()"></i>
        <i class="bi bi-clock-history" title="Chat History"></i>
        <i class="bi bi-chat-dots" title="Start new conversation" (click)="resetChat()"></i>
        <i class="bi bi-x" title="Minimize chat" (click)="close()"></i>
      </div>
    </div>

    <div class="chat-body" #chatBody>
      <ng-container *ngFor="let msg of history">
        <div class="message"
          [ngClass]="{'user': msg.role === 'user', 'model': msg.role === 'model', 'streaming': msg.isStreaming}">
          <div class="message-container">
            <div class="message-image">
              <img *ngIf="msg.role === 'user'" [src]="userAvatarSrc" alt="User" class="message-avatar">
              <img *ngIf="msg.role === 'model'" [src]="msg.avatar || aiAvatarSrc" alt="AI" class="message-avatar">
            </div>
            <div class="message-text">
              <div class="timestamp">{{ msg.timestamp | date:'EEEE h:mma' }}</div>
              <div class="message-content">
                <span *ngIf="msg.message && msg.role === 'user'">{{ msg.message }}</span>
                <span *ngIf="msg.message && msg.role === 'model'" [innerHTML]="parseMessageLinks(msg.message)"></span>
                <span *ngIf="msg.isStreaming && !msg.message && msg.role === 'user'"
                  class="listening-text">Listening...</span>
                <span *ngIf="msg.isStreaming && msg.role === 'user'" class="recording-indicator"></span>
                <span *ngIf="msg.isStreaming && msg.role === 'model'" class="speaking-indicator"></span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <div *ngIf="isThinking" class="message model">
        <div class="message-container">
          <div class="message-image">
            <img [src]="aiAvatarSrc" alt="AI" class="message-avatar">
          </div>
          <div class="message-text">
            <div class="message-content">
              <div class="loading-animation">
                <span class="dot"></span><span class="dot"></span><span class="dot"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="chat-footer">
      <app-ai-search-bar [placeholder]="'Reply...'" [(value)]="inputValue" [isRecording]="isRecording"
        (search)="onSend($event)" (voiceInput)="onVoiceInput()"></app-ai-search-bar>
    </div>
  </div>
</div>